import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/projects/$id")({
  staticData: {
    title: "projects.title",
  },
});
